import React, { forwardRef } from 'react';
import { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { Container, Grid, useMediaQuery, useTheme } from '@mui/material';
import OTPInput from 'otp-input-react';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import SendIcon from '@mui/icons-material/Send';
import DeleteIcon from '@mui/icons-material/Delete';
import { useSelector, useDispatch } from 'react-redux';
import {
  closeOtpModal,
  setEcommerceOff,
  setEcommerceOn,
  setCVV2,
  updateBalance,
} from '../../redux/create-actions/OtpAction';
import { showAlert } from '../../redux/create-actions/AlertAction';
import {
  goToNextStep,
  updateOnboardingData,
} from '../../redux/create-actions/OnboardingAction';
import { validateOTP } from '../../utils/regex/Regex';
import {
  closeLoadingApi,
  openLoadingApi,
} from '../../redux/create-actions/LoadingAction';
import Color from '../Color';
import FontSize from '../FontSize';
import { graphVerifyOtp } from '../../services/Onboarding';
import { graphOnUsTransfer } from '../../services/Transfer';
import { graphGenOtp } from '../../services/OneTimePassword';
import { graphChangePin, graphSetPin, graphSetUsageLimiter, retrieveCVV2OTP, switchEcommerceStatusOTP } from '../../services/CardOperation';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const countDown = { fontSize: '12px' };
const dialogAct = { gap: 2 };
const dialogText = { fontFamily: "'Asap', normal" }

export default function OtpModal() {
  const theme = useTheme();
  const matchDownSM = useMediaQuery(theme.breakpoints.down('sm'));
  const data = useSelector((state) => state.otp.data);
  const [otp, setOtp] = useState('');
  const [time, setTime] = useState(120);
  const [wrong, setWrong] = useState(3);

  const dispatch = useDispatch();

  const handleVerify = () => {
    let validate = validateOTP(otp);
    let alert = {
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'center',
      },
      isOpen: true,
      severity: 'error',
      title: 'Error',
      message: '',
    };
    if (!validate) {
      alert = { ...alert, message: 'Please select correct OTP format!' };
      dispatch(showAlert(alert));
    } else {
      let feature = data.feature;
      switch (feature) {
        case 'ONBOARDING':
          dispatch(openLoadingApi());
          setOtp('');
          let promise = graphVerifyOtp(otp, data.customerId);
          promise
            .then((result) => {
              alert = {
                ...alert,
                severity: 'success',
                title: 'Success',
                message: 'Verify OTP successful',
              };
              dispatch(closeLoadingApi());
              dispatch(closeOtpModal(alert));
              dispatch(goToNextStep());
              dispatch(showAlert(alert));
              dispatch(updateOnboardingData(result));
            })
            .catch(function (error) {
              const err = JSON.parse(JSON.stringify(error));

              alert = { ...alert, message: err.response.errors[0].message };
              dispatch(closeLoadingApi());
              dispatch(showAlert(alert));
              dispatch(closeOtpModal());
            });
          break;
        case 'ECOMMERCE_ON':
          dispatch(openLoadingApi());
          setOtp('');
          const data2 = {
            contractId: parseInt(data.contractId),
            ecomStatus: 'ON'
          }
          let ecomStatus = switchEcommerceStatusOTP(data2, parseInt(otp));
          ecomStatus
            .then((result2) => {
              if (result2.status === '0') {
                alert = {
                  ...alert,
                  severity: 'success',
                  title: 'Success',
                  message: 'Ecommerce transaction was allowed!',
                };
                dispatch(closeLoadingApi());
                dispatch(setEcommerceOn());
                dispatch(closeOtpModal());
                dispatch(showAlert(alert));
              } else {
                alert = {
                  ...alert,
                  severity: 'success',
                  title: 'Success',
                  message: result2.data.RetMsg._text,
                };
                dispatch(closeLoadingApi());
                dispatch(closeOtpModal());
                dispatch(showAlert(alert));
              }

            })
            .catch(function (error) {
              setWrong(wrong - 1);
              const err = JSON.parse(JSON.stringify(error))
              alert = { ...alert, message: err.response.errors[0].message };
              dispatch(closeLoadingApi());
              dispatch(showAlert(alert));
              dispatch(closeOtpModal());
            });
          break;
        case 'ECOMMERCE_OFF':
          dispatch(openLoadingApi());
          setOtp('');
          const data1 = {
            contractId: parseInt(data.contractId),
            ecomStatus: 'OFF'
          }
          let ecomStatusOff = switchEcommerceStatusOTP(data1, parseInt(otp));
          ecomStatusOff
            .then((result2) => {
              if (result2.status === '0') {
                alert = {
                  ...alert,
                  severity: 'success',
                  title: 'Success',
                  message: 'Ecommerce transaction was not allowed!',
                };
                dispatch(closeLoadingApi());
                dispatch(setEcommerceOff());
                dispatch(closeOtpModal());
                dispatch(showAlert(alert));
              } else {
                alert = {
                  ...alert,
                  severity: 'success',
                  title: 'Success',
                  message: result2.data.RetMsg._text,
                };
                dispatch(closeLoadingApi());
                dispatch(closeOtpModal());
                dispatch(showAlert(alert));
              }

            })
            .catch(function (error) {
              setWrong(wrong - 1);
              const err = JSON.parse(JSON.stringify(error))
              alert = { ...alert, message: err.response.errors[0].message };
              dispatch(closeLoadingApi());
              dispatch(showAlert(alert));
              dispatch(closeOtpModal());
            });
          break;
        case 'SHOW_CVV2':
          dispatch(openLoadingApi());
          setOtp('');
          const data3 = {
            contractId: parseInt(data.contractId)
          }
          let showCVV2 = retrieveCVV2OTP(data3, otp);
          showCVV2
            .then((result2) => {
              if (result2.status === '0') {
                alert = {
                  ...alert,
                  severity: 'success',
                  title: 'Success',
                  message: result2.data.RetMsg._text,
                };
                dispatch(closeLoadingApi());
                dispatch(closeOtpModal());
                dispatch(showAlert(alert));
                dispatch(setCVV2(result2.data.SecurityCode._text));
              } else {
                alert = {
                  ...alert,
                  severity: 'error',
                  title: 'Error',
                  message: result2.data.RetMsg._text,
                };
                dispatch(closeLoadingApi());
                dispatch(closeOtpModal());
                dispatch(showAlert(alert));
              }
            })
            .catch(function (error) {
              setWrong(wrong - 1);
              const err = JSON.parse(JSON.stringify(error))
              alert = { ...alert, message: err.response.errors[0].message };
              dispatch(closeLoadingApi());
              dispatch(showAlert(alert));
              dispatch(closeOtpModal());
            });
          break;
        case 'CHANGE_PIN':
          dispatch(openLoadingApi());
          setOtp('');
          let changePin = graphChangePin(
            data.contractId,
            data.newPin,
            data.oldPin,
            otp,
          );
          changePin
            .then((result2) => {
              if (result2.status === '0') {
                alert = {
                  ...alert,
                  severity: 'success',
                  title: 'Success',
                  message: 'Change PIN successful!',
                };
                dispatch(closeLoadingApi());
                dispatch(closeOtpModal());
                dispatch(showAlert(alert));
              } else {
                alert = { ...alert, message: result2.data.RetMsg._text };
                dispatch(showAlert(alert));
                dispatch(closeLoadingApi());
                dispatch(closeOtpModal());
              }
            })
            .catch(function (error) {
              setWrong(wrong - 1);
              const err = JSON.parse(JSON.stringify(error))
              alert = { ...alert, message: err.response.errors[0].message };
              dispatch(closeLoadingApi());
              dispatch(showAlert(alert));
              dispatch(closeOtpModal());
            });
          break;
        case 'SET_PIN':
          dispatch(openLoadingApi());
          setOtp('');
          let setPin = graphSetPin(data.contractId, data.newPin, otp);
          setPin
            .then((result2) => {
              if (result2.status === '0') {
                alert = {
                  ...alert,
                  severity: 'success',
                  title: 'Success',
                  message: 'Set PIN successful!',
                };
                dispatch(closeLoadingApi());
                dispatch(closeOtpModal());
                dispatch(showAlert(alert));
              } else {
                alert = {
                  ...alert,
                  severity: 'error',
                  title: 'Error',
                  message: result2.data.RetMsg._text,
                };
                dispatch(closeLoadingApi());
                dispatch(showAlert(alert));
                dispatch(closeOtpModal());
              }
            })
            .catch(function (error) {
              setWrong(wrong - 1);
              const err = JSON.parse(JSON.stringify(error))
              alert = { ...alert, message: err.response.errors[0].message };
              dispatch(closeLoadingApi());
              dispatch(showAlert(alert));
              dispatch(closeOtpModal());
            });
          break;
        case 'INTRABANK_TRANSFER':
          dispatch(openLoadingApi());
          setOtp('');
          let intrabankTransfer = graphOnUsTransfer(
            data.sourceNumber,
            'CBS_NUMBER',
            data.targetNumber,
            data.message,
            data.amount,
            otp
          );
          intrabankTransfer
            .then((result2) => {
              if (result2.status === '0') {
                alert = {
                  ...alert,
                  severity: 'success',
                  title: 'Success',
                  message: 'Transfer successful!',
                };
                dispatch(closeLoadingApi());
                dispatch(updateBalance());
                dispatch(closeOtpModal());
                dispatch(showAlert(alert));
              } else {
                alert = { ...alert, message: result2.additionalData };
                dispatch(showAlert(alert));
                dispatch(closeLoadingApi());
                dispatch(closeOtpModal());
              }
            })
            .catch(function (error) {
              setWrong(wrong - 1);
              const err = JSON.parse(JSON.stringify(error))
              alert = { ...alert, message: err.response.errors[0].message };
              dispatch(closeLoadingApi());
              dispatch(showAlert(alert));
            });
          break;
        case 'TRANSFER_247':
          break;
        case 'USAGE_LIMITER':
          console.log(1)
          dispatch(openLoadingApi());
          setOtp('');
          let setLimiter = graphSetUsageLimiter(
            data.variables,
            otp,
          );
          setLimiter
            .then((result) => {
              console.log(result)
              if (result.status === '0') {
                alert = {
                  ...alert,
                  severity: 'success',
                  title: 'Success',
                  message: 'Change usage limit successfully!',
                };
                dispatch(closeLoadingApi());
                dispatch(closeOtpModal());
                dispatch(showAlert(alert));
              } else {
                alert = { ...alert, message: result.data.RetMsg._text };
                dispatch(showAlert(alert));
                dispatch(closeLoadingApi());
                dispatch(closeOtpModal());
              }
            })
            .catch(function (error) {
              setWrong(wrong - 1);
              const err = JSON.parse(JSON.stringify(error))
              alert = { ...alert, message: err.response.errors[0].message };
              dispatch(closeLoadingApi());
              dispatch(showAlert(alert));
              dispatch(closeOtpModal());
            });
          break;
        default:
          break;
      }
    }
  };

  const handleClose = () => {
    setOtp('');
    setTime(120);
    setWrong(3);
    dispatch(closeOtpModal());
  };

  const handleResend = () => {
    let alert = {
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'center',
      },
      isOpen: true,
      severity: 'error',
      title: 'Error',
      message: '',
    };
    let generateOtp = graphGenOtp();
    generateOtp
      .then((result) => {
        alert = {
          ...alert,
          severity: 'success',
          title: 'Success',
          message: 'Resend OTP successful!',
        };
        dispatch(showAlert(alert));
      })
      .catch(function (error) {
        const err = JSON.parse(JSON.stringify(error))
        alert = { ...alert, message: err.response.errors[0].message };
        dispatch(showAlert(alert));
      });
  };

  const enterOtp = (event) => {
    var value = otp ? event : otp + event;
    setOtp(value);
  };

  useEffect(() => {
    if (wrong === 0) {
      setOtp('');
      setTime(120);
      setWrong(3);
      dispatch(closeOtpModal());
    }
  }, [wrong, dispatch]);

  const renderTimeRemainingCircle = (open, time) => {
    return open ? (
      <CountdownCircleTimer
        isPlaying={open}
        duration={time}
        colors={[Color.Success, Color.Information, Color.Warning, Color.Dangerous]}
        colorsTime={[120, 60, 30, 0]}
        sx={countDown}
        size={matchDownSM ? '60' : '90'}
        strokeWidth={matchDownSM ? '3' : '5'}
        onComplete={handleClose}
      >
        {({ remainingTime }) => remainingTime}
      </CountdownCircleTimer>
    ) : (
      <div></div>
    );
  };

  return (
    <Container maxWidth="xs">
      <Dialog
        onClose={handleClose}
        open={data.isOpen}
        TransitionComponent={Transition}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
        style={{
          height: `${matchDownSM ? '90%' : '100%'}`,
          marginTop: `${matchDownSM ? '-100px' : '-100px'}`,
        }}
      >
        <Grid
          container
          spacing={2}
          justifyContent="center"
          alignItems="center"
          direction="column"
          sx={{
            p: `${matchDownSM ? '18px' : '20px'}`,
            backgroundColor: theme.palette.background.default,
          }}
        >
          {/* {process.env.REACT_APP_PRODUCT_TYPE === 'non-pro' && ( */}
            <>
              <Grid
                item xs={12}
                sx={{
                  fontSize: FontSize.Medium,
                  fontFamily: "'Asap', normal",
                  fontWeight: 600,
                  color: '#FF0000'
                }}
              >
                In non production version
              </Grid>
              <Grid
                item xs={12}
                sx={{
                  fontSize: FontSize.Medium,
                  fontFamily: "'Asap', normal",
                  fontWeight: 600,
                  color: '#FF0000'
                }}
              >
                You can enter any OTP code to verify!
              </Grid>
            </>

          {/* )} */}
          <Grid item xs={12}>
            <DialogTitle
              onClose={handleClose}
              sx={{ pb: `${matchDownSM ? '0px' : '24px'}`, fontSize: FontSize.Small, fontFamily: "'Asap', normal", fontWeight: 600 }}
            >
              Enter OTP Code
            </DialogTitle>
          </Grid>
          <Grid item xs={12}>
            <OTPInput
              value={otp}
              onChange={enterOtp}
              autoFocus
              OTPLength={6}
              inputStyles={{
                marginRight: `${matchDownSM ? '2px' : '20px'}`,
                outline: 'none',
                border: '1px solid #fff',
                borderBottom: '1px solid #999',
              }}
              otpType="number"
              disabled={false}
              style={{
                marginLeft: ` ${matchDownSM ? '5px' : '20px'}`,
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <DialogContent
              sx={{
                p: `${matchDownSM ? '5px' : '20px'}`,
              }}
            >
              <DialogContentText
                id="alert-dialog-slide-description"
                color={Color.Main}
                fontSize={matchDownSM ? '12px' : '16px'}
                sx={dialogText}
              >
                Don't receive OTP code,
                <Button
                  variant="contained"
                  size={matchDownSM ? 'small' : 'medium'}
                  sx={{
                    color: '#fff',
                    fontSize: `${matchDownSM ? '10px' : '14px'}`,
                    lineHeight: '1.5',
                    textTransform: 'capitalize',
                    padding: '5px 10px',
                    marginLeft: '5px',
                    display: 'inline',
                  }}
                  endIcon={<SendIcon />}
                  onClick={handleResend}
                >
                  Resend
                </Button>
              </DialogContentText>
            </DialogContent>
          </Grid>
          <Grid item xs={12}>
            {renderTimeRemainingCircle(data.isOpen, time)}
          </Grid>
          <Grid item xs={12}>
            <DialogActions sx={dialogAct}>
              <Button
                variant="contained"
                size={matchDownSM ? 'small' : 'medium'}
                endIcon={<DeleteIcon />}
                sx={{
                  bgcolor: Color.Dangerous,
                  textAlign: 'center',
                  maxWidth: '250px',
                  fontSize: `${matchDownSM ? '12px' : '16px'}`,
                  '&:hover': { background: Color.Button, color: Color.Normal }
                }}
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                size={matchDownSM ? 'small' : 'medium'}
                endIcon={<SendIcon />}
                sx={{
                  bgcolor: Color.Main,
                  textAlign: 'center',
                  maxWidth: '250px',
                  fontSize: `${matchDownSM ? '12px' : '16px'}`,
                  '&:hover': { background: Color.Button, color: Color.Normal }
                }}
                onClick={handleVerify}
              >
                Verify
              </Button>
            </DialogActions>
          </Grid>
        </Grid>
      </Dialog>
    </Container >
  );
}
